import { Cookies } from 'react-cookie';
export const useCheckAuthentication = () => {
  const cookies = new Cookies();
  const haveToken = cookies.get('accessToken')?.length > 0;
  // const { isLogged } = useSelector(selectAuth);

  let isAuthenticated = haveToken;
  return isAuthenticated;
};
